<template>
    <v-row class="d-flex justify-center mt-0">
        <v-col cols="12">
            <!-- FILTROS -->
            <v-expansion-panels v-model="panel">
                <v-expansion-panel readonly>
                    <v-btn style="position: absolute; top: -15px; right: 55px; z-index: 1" color="success"
                        title="Cargar Ticket" small fab @click="dialog = true; titulo = null">
                        <v-icon>fas fa-plus</v-icon>
                    </v-btn>
                    <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
                        <div>
                            <v-icon class="mb-1" left>fas fa-filter</v-icon>
                            Filtro
                        </div>
                        <template v-slot:actions>
                            <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                                <v-icon>fas fa-chevron-down</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-1">
                        <v-form @submit.prevent="buscar()">
                            <v-row>
                                <v-col cols="5" sm="2" class="py-1">
                                    Número
                                    <v-text-field v-model.trim="filtro.id" tabindex="1" type="number" hide-details
                                        outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="7" sm="3" xl="2" class="py-1">
                                    Estado
                                    <v-autocomplete v-model="filtro.estado" item-text="nombre" item-value="estado_id"
                                        tabindex="1" :items="estados" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>
                                <!-- ESTE VER CON PERMISOS -->
                                <v-col cols="12" sm="3" xl="2" class="py-1">
                                    Tipo
                                    <v-autocomplete v-model="filtro.tipo" item-text="nombre" item-value="tipo_id"
                                        tabindex="1" :items="tipos_tickets" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>
                                <v-col v-if="permisos.visualizarTodasAreas" cols="6" sm="3" xl="2" class="py-1">
                                    Area
                                    <v-autocomplete v-model="filtro.area" item-text="nombre" item-value="area_id"
                                        tabindex="1" :items="areas" hide-details clearable outlined
                                        dense></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="4" class="py-1">
                                    Asunto
                                    <v-text-field v-model.trim="filtro.asunto" tabindex="1" hide-details outlined
                                        dense></v-text-field>
                                </v-col>
                                <v-col v-if="permisos.visualizarArea || permisos.visualizarTodasAreas" cols="6"
                                    sm="3" md="3" class="py-1">
                                    Período creación
                                    <PeriodoPicker v-model="filtro.periodo_creacion" clearable hide-details />
                                </v-col>
                                <v-col v-if="mostrarFiltroMisTickets" cols="12" sm="3" md="3"
                                    class="py-1 mb-3 d-flex align-end">
                                    <v-switch
                                        v-model="filtro.ver_mis_propios_tickets"
                                        label="Ver mis propios tickets"
                                        color="info"
                                        dense
                                        hide-details
                                        inset
                                    ></v-switch>
                                </v-col>
                                <BtnFiltro :loading="load" @clear="limpiar()" />
                            </v-row>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <!-- DATA TABLE -->
            <v-data-table v-model="selected" :single-select="true" class="cebra elevation-2 mt-2" sort-by="ticket_id"
                :items="tickets" @click:row="rowClick" :headers="headers" :loading="load" :search="search"
                :item-class="getRowClass" sort-desc dense :item-key="'ticket_id'">

                <!-- busqueda local -->
                <template v-slot:top>
                    <v-row class="d-flex  pa-2" no-gutters style="justify-content: space-between;">

                        <!-- HABILTAR UNA VEZ TENGAN LAS AREAS DEFINIDAS -->
                        <div v-if="permisos.reporteDescargar" class="">
                            <v-btn @click="descargarReporte()" class="mr-2 my-sm-0 my-1 py-sm-0 py-3"
                                title="Descargar Excel" :x-small="$vuetify.breakpoint.xs"
                                :small="!$vuetify.breakpoint.xs">
                                reporte
                                <v-icon color="green darken-3" :small="$vuetify.breakpoint.xs" right>
                                    fas fa-file-download
                                </v-icon>
                            </v-btn>
                        </div>
                        <div />

                        <v-col cols="6" sm="3" xl="2" class="">
                            <SearchDataTable v-model="search" />
                        </v-col>
                    </v-row>
                </template>
                <!--template para formatos personalizados -->
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    {{ header.formatter(value) }}
                </template>
                <!-- estado colores -->
                <template v-slot:[`item.estado_nombre`]="{ item }">
                    <v-chip
                        :color="estados.find(e => e.estado_id == item.estado_id) ? estados.find(e => e.estado_id == item.estado_id).color : ''"
                        small>
                        {{ item.estado_nombre }}
                    </v-chip>
                </template>
                <!-- no data -->
                <template v-slot:no-data>
                    <v-alert class="mx-auto mt-4" max-width="400" type="warning" border="left" dense text>
                        No hay datos para los filtros seleccionados
                    </v-alert>
                </template>
            </v-data-table>
            <!-- VISUALIZACION DE TICKETS -->
            <v-expand-transition>
                <section id="detalle">
                    <!-- DETALLE -->
                    <v-card v-if="selected.length > 0" class="my-2">
                        <v-card-title class="d-flex justify-end pb-0 pt-1 pr-1">
                            <v-btn title="Cerrar detalle" icon x-small @click="selected = []">
                                <v-icon>fas fa-times</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-title class="py-2" style="word-break: normal">
                            Ticket Nº {{ selected[0].ticket_id }} - {{ selected[0].asunto }}
                            <v-spacer></v-spacer>
                            <v-chip
                                :color="estados.find(e => e.estado_id == selected[0].estado_id) ? estados.find(e => e.estado_id == selected[0].estado_id).color : ''">
                                {{ selected[0].estado_nombre }}
                            </v-chip>
                        </v-card-title>
                        <v-col cols="12" class="d-flex mt-n4 pb-0 px-4" style="font-size: 13px;">
                            Cargado por {{ selected[0].solicitante_nombre }} el {{
                                moment.utc(selected[0].fecha_creacion).format('DD/MM/YY [a las] HH:mm') }}
                        </v-col>
                        <v-card-text class="pt-1">
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="selected[0].descripcion" rows="3" hide-details auto-grow
                                        outlined readonly filled dense></v-textarea>
                                </v-col>
                                <v-col
                                    v-if="archivos.filter(a => a.comentario_id == null && a.respuesta != 1).length > 0"
                                    cols="12" class="pt-0">
                                    <v-chip
                                        v-for="(archivo, index) in archivos.filter(a => a.comentario_id == null && a.respuesta != 1)"
                                        class="mb-1 mr-2" :color="get_atributo_x_extension(archivo.extension, 'color')"
                                        :key="index" dark @click="ver_archivo(archivo, '')">
                                        <v-icon class="ml-1" left>{{ get_atributo_x_extension(archivo.extension,
                                            'icono')
                                            }}</v-icon>
                                        {{ archivo.nombre }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- COMENTARIOS -->
                    <v-card v-if="selected.length > 0 && !(comentarios.length == 0 && selected[0].respuesta)">
                        <v-card-title class="py-2" style="word-break: normal">
                            Comentarios
                        </v-card-title>
                        <v-card-text>
                            <v-row v-if="load_comentario">
                                <v-skeleton-loader style="width: 100%;"
                                    type="list-item-avatar-three-line"></v-skeleton-loader>
                                <v-skeleton-loader style="width: 100%;" type="actions"></v-skeleton-loader>
                            </v-row>
                            <v-row v-else>
                                <!-- "chat" -->
                                <v-col v-for="(comentario, index) in comentarios" :key="index" cols="12" class="d-flex">
                                    <!-- icono usuario -->
                                    <v-avatar v-if="comentario.es_comentario_mesa != 1 && !$vuetify.breakpoint.xs"
                                        color="cyan" class="mr-3" style="font-size:22px; cursor: default">
                                        <v-icon>fas fa-user</v-icon>
                                    </v-avatar>
                                    <v-card style="width: 100%;">
                                        <v-card-text class="d-flex pb-1 pt-2 px-3">
                                            <span class="font-weight-bold body-1">
                                                {{ comentario.usuario_nombre }}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <span class="text-right">
                                                {{ moment.utc(comentario.fecha).format('DD/MM/YYYY HH:mm') }}
                                            </span>
                                        </v-card-text>
                                        <!-- comentario -->
                                        <v-card-text class="d-flex py-0 pb-1 px-3 body-1">
                                            {{ comentario.descripcion }}
                                        </v-card-text>
                                        <!-- archivos -->
                                        <v-card-text class="py-1 px-3">
                                            <v-chip
                                                v-for="(archivo, index) in archivos.filter(a => a.comentario_id == comentario.comentario_id)"
                                                class="mb-1 mr-2"
                                                :color="get_atributo_x_extension(archivo.extension, 'color')"
                                                :key="index" small dark @click="ver_archivo(archivo)">
                                                <v-icon class="ml-1" small left>{{
                                                    get_atributo_x_extension(archivo.extension,
                                                        'icono') }}</v-icon>
                                                {{ archivo.nombre }}
                                            </v-chip>
                                        </v-card-text>
                                    </v-card>
                                    <!-- icono admin -->
                                    <v-avatar v-if="comentario.es_comentario_mesa == 1 && !$vuetify.breakpoint.xs"
                                        :color="$vuetify.theme.dark ? 'lime darken-1' : 'lime'" class="ml-3"
                                        style="font-size:22px; cursor: default">
                                        <v-icon>fas fa-desktop</v-icon>
                                    </v-avatar>
                                </v-col>
                                <!-- enviar comentario -->
                                <template v-if="!selected[0].respuesta">
                                    <v-col cols="12" sm="10">
                                        <v-textarea v-model.trim="comentario" rows="2" hide-details outlined
                                            dense></v-textarea>
                                        <div v-if="archivos_adjuntos.length > 0" class="mt-1">
                                            <strong>
                                                {{ archivos_adjuntos.length }} archivo{{ archivos_adjuntos.length == 1 ?
                                                    '' : 's' }} adjunto{{ archivos_adjuntos.length == 1 ? '' : 's' }}:
                                            </strong>
                                            {{archivos_adjuntos.map(a => a.name).join(', ')}}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="2" class="d-flex justify-end align-center">
                                        <v-btn color="info" class="mr-3" title="Adjuntar archivos" small fab
                                            @click="dialog_archivos = true">
                                            <v-icon>fas fa-paperclip</v-icon>
                                        </v-btn>
                                        <v-btn color="success" class="mr-0 mr-md-3" title="Enviar comentario" small fab
                                            @click="enviar_comentario()">
                                            <v-icon class="mr-1">fas fa-paper-plane</v-icon>
                                        </v-btn>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- RESPUESTA -->
                    <v-card v-if="selected.length > 0 && selected[0].respuesta" class="mt-2">
                        <v-card-title class="pt-2 pb-0" style="word-break: normal">
                            Respuesta
                        </v-card-title>
                        <div class="body-1 mx-4">
                            Finalizado por {{ selected[0].usuario_finalizacion_nombre }} el {{
                                moment.utc(selected[0].fecha_finalizacion).format('DD/MM/YY [a las] HH:mm') }}
                        </div>
                        <v-card-text class="pt-2">
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="selected[0].respuesta.descripcion" rows="3" hide-details
                                        auto-grow outlined readonly filled dense></v-textarea>
                                </v-col>
                                <v-col cols="12" class="pt-0">
                                    <v-chip
                                        v-for="(archivo, index) in archivos.filter(a => (a.comentario_id === selected[0].archivos.find(ar => ar.comentario_id === a.comentario_id)?.comentario_id) && a.estado_ticket_id === 3)"
                                        class="mb-1 mr-2" :color="get_atributo_x_extension(archivo.extension, 'color')"
                                        :key="index" dark @click="ver_archivo(archivo)">
                                        <v-icon class="ml-1" left>{{ get_atributo_x_extension(archivo.extension,
                                            'icono')
                                            }}</v-icon>
                                        {{ archivo.nombre }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="d-flex pt-0 pb-3 justify-end mx-2">
                            <v-btn color="warning"
                                @click="dialog = true; titulo = `Reabierto Nº${selected[0].ticket_id} - ${selected[0].asunto}`">
                                <v-icon left>fas fa-reply</v-icon>
                                Reabrir ticket
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </section>
            </v-expand-transition>
        </v-col>
        <!-- COMPONENTES -->
        <NuevoTicket v-model="dialog" :titulo="titulo" @actualizar="buscar()" />
        <PDFViewer v-model="dialog_pdf" :pdf="pdf" :nombre="nombre_ver" :titulo="nombre_ver" />
        <ImgViewer v-model="dialog_img" :img="img" :nombre="nombre_ver" />
        <AdjuntarArchivos v-model="dialog_archivos" :archivos.sync="archivos_adjuntos" />
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { format_date, tipos_archivos, getBase64 } from '../../util/utils'
import BtnFiltro from '../../components/util/BtnFiltro.vue';
import FechaPicker from '../../components/util/FechaPicker'
import BtnConfirmar from '../../components/util/BtnConfirmar'
import ImgViewer from '../../components/util/ImgViewer'
import PDFViewer from '../../util/plantillas/PDFViewer'
import AdjuntarArchivos from '../../components/incidentes/AdjuntarArchivos'
import SearchDataTable from '../../components/util/SearchDataTable'
import moment from 'moment'
import tickets from '../../modules/tickets/tickets';
import NuevoTicket from '../../components/tickets/NuevoTicket.vue';
import { convertImageToWebp } from '../../util/imagenes';
import PeriodoPicker from '../../components/util/PeriodoPicker.vue';
import FileSaver from 'file-saver'
import { read, utils, write } from 'xlsx'

export default {
    data() {
        return {
            id: this.$route.params.id,
            personal_id: 0,
            moment: moment,
            panel: 0,
            load: false,
            load_comentario: false,
            dialog: false,
            dialog_img: false,
            dialog_pdf: false,
            dialog_archivos: false,
            comentario: '',
            nombre_ver: '',
            titulo: '',
            search: '',
            pdf: null,
            img: null,
            selected: [],
            archivos: [],
            archivos_adjuntos: [],
            comentarios: [],
            tickets: [],
            roles_de_usuario: [],
            headers: [
                { text: 'Número', value: 'ticket_id', align: 'center' },
                { text: 'Solicitante', value: 'solicitante_usuario', sortable: false },
                { text: 'Asunto', value: 'asunto', sortable: false },
                { text: 'Estado', value: 'estado_nombre' },
                { text: 'Tipo', value: 'tipo_ticket_nombre' },
                { text: 'Fecha creación', value: 'fecha_creacion', formatter: format_date },
                { text: 'Usuario asignado', value: 'usuario_asignado_nombre', sortable: false },
                { text: 'Fecha finalización', value: 'fecha_finalizacion', formatter: format_date },
                { text: 'Usuario finalización', value: 'usuario_finalizacion', sortable: false }
            ],
            filtro: {
                id: '',
                asunto: '',
                estado: null,
                tipo: null,
                periodo_creacion: '',
                area: null,
                ver_mis_propios_tickets: false
            },

            estados: [],
            nombreUs: '',

            usuariosMesa: [],

            tipos_tickets: [],
            areas: [],
            area_usuario: {},
            permisos: {
                visualizarArea: false,
                visualizarTodasAreas: false,
                reporteDescargar: false
            },
            modalDescargar: false
        }
    },
    async created() {
        this.$store.state.loading = true
        await this.$store.dispatch('tickets/permisos').then(res => {
            if (res.exito) {
                this.permisos = {
                    ...this.permisos,
                    ...(res.permisos || {})
                }
            }
        })
        await this.$store.dispatch('tickets/getEstadosTickets').then(res => {
            if (res.exito) {
                this.estados = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        await this.$store.dispatch('tickets/getInfoMesa').then(res => {
            if (res.exito) {
                this.usuariosMesa = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })

        await this.$store.dispatch('tickets/getAreas').then(res => {
            if (res.exito) {
                this.areas = res.data
                this.areas = this.areas.sort((a, b) =>
                    a.nombre.localeCompare(b.nombre)
                )
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }

        })

        await this.$store.dispatch('tickets/getTiposTickets').then(res => {
            if (res.exito) {
                this.tipos_tickets = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        await this.$store.dispatch('usuarios/getAreaDelUsuario').then(res => {
            if (res.exito) {
                this.area_usuario = res.data


                // PROBAR ACA EL AREA DEL USUARIO PARA LOS DE GERENCIA
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })

        if (this.id) {
            this.filtro.id = this.id
        }
        await this.buscar()

        await this.$store.dispatch('roles/getRolesDelUsuario').then(res => {
            if (res.exito) {
                this.roles_de_usuario = res.data
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        this.$store.state.loading = false
    },
    computed: {
        ...mapState(['familias']),
        mostrarFiltroMisTickets() {
            return this.permisos.visualizarArea || this.permisos.visualizarTodasAreas
        }
    },
    components: {
        ImgViewer,
        PDFViewer,
        BtnFiltro,
        FechaPicker,
        BtnConfirmar,
        NuevoTicket,
        AdjuntarArchivos,
        SearchDataTable,
        PeriodoPicker
    },
    watch: {
        async '$route.params.id'(newId) {
            this.id = newId || null
            this.filtro.id = this.id || ''
            await this.buscar()
        },
        async selected(newVal, oldVal) {
            this.archivos = []
            this.comentarios = []
            this.archivos_adjuntos = []
            this.comentario = ''


            if (this.selected[0]) {
                if (this.selected[0].archivos) {
                    this.archivos = this.selected[0].archivos
                }
                if (this.selected[0].comentarios) {
                    this.comentarios = this.selected[0].comentarios
                }
            }
            // obtiene las imagenes del registro seleccionado solo cuando lo selecciona por primera vez
            if (newVal.length == 1 && ((oldVal.length == 0) || (oldVal[0].ticket_id != newVal[0].ticket_id))) {
                const id = await JSON.parse(JSON.stringify(this.selected[0].ticket_id))
                let selected = this.tickets.find(c => c.ticket_id == id)
                if (!selected.archivos) {
                    this.$store.state.loading = true
                    this.load_comentario = true
                    await this.$store.dispatch('tickets/getArchivos', { id: selected.ticket_id })
                        .then((res) => {

                            selected.archivos = res.data
                            this.archivos = selected.archivos
                        })
                        .catch(error => {
                            this.$store.dispatch('show_snackbar', {
                                text: error.message,
                                color: 'error'
                            })
                        })
                    this.$store.state.loading = false
                    this.load_comentario = false
                }
                if (!selected.comentarios) {
                    this.load_comentario = true
                    await this.$store.dispatch('tickets/getComentarios', { id: selected.ticket_id })
                        .then((res) => {
                            let es_dba = this.roles_de_usuario.some(rol => rol.Rol_id === 1)
                            selected.comentarios = res.data.filter(data => data.estado_ticket_id != 3)
                            if (!es_dba) {
                                selected.comentarios = selected.comentarios.filter(data => (!data.es_comentario_interno))
                                this.comentarios = selected.comentarios
                            }
                            this.comentarios = selected.comentarios
                            const comentarioFinalizacion = res.data.find(coment => coment.estado_ticket_id === 3)
                            if (comentarioFinalizacion) {
                                selected.respuesta = comentarioFinalizacion
                            }
                        })
                        .catch(error => {
                            this.$store.dispatch('show_snackbar', {
                                text: error.message,
                                color: 'error'
                            })
                        })
                    this.load_comentario = false
                }
            }
        }
    },
    methods: {
        getRowClass(item) {
            return this.selected.length > 0 && this.selected[0].ticket_id === item.ticket_id
                ? 'v-data-table__selected'
                : '';
        },

        async buscar() {
            this.tickets = []
            this.selected = []
            this.search = ''
            this.load = true

            await this.$store.dispatch('tickets/getTicketsDelUsuario', this.filtro)
                .then((res) => {
                    if (res.exito) {
                        this.tickets = res.data
                        this.tickets.forEach(ticket => {
                            ticket.estado_nombre = this.estados.find(estado => estado.estado_id === ticket.estado_id)?.nombre
                            ticket.usuario_asignado_nombre = this.usuariosMesa.find(us => us.Usuario_id === ticket.usuario_asignado)?.Username
                        })
                        this.permisos = {
                            ...this.permisos,
                            ...(res.permisos || {})
                        }
                    }
                    else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        })
                    }
                })

            this.load = false
        },


        async enviar_comentario() {
            if (!this.comentario.trim()) {
                return this.$store.dispatch('show_snackbar', {
                    text: 'No puede enviar un comentario vacio',
                    color: 'orange'
                })
            }
            // valido si en algun lado del comentario puso adjunto para avisarle por si no adjuntó nada
            const tiene_adjunto = this.comentario.toLowerCase().indexOf('adjunto') >= 0
            const tiene_archivo = this.comentario.toLowerCase().indexOf('archivo') >= 0
            if ((tiene_adjunto || tiene_archivo) && this.archivos_adjuntos.length == 0) {
                let ups_me_olvide_el_archivo = false
                let abrir_modal = false
                await this.$swal.fire({
                    icon: 'warning',
                    html: `Se encontró la palabra <strong>${tiene_archivo ? 'archivo' : ''} ${tiene_adjunto ? 'adjunto' : ''}</strong> en el comentario pero no se
            seleccionó ningún archivo.<div style="font-size: 20px; margin-top: 12px"><strong>¿Desea enviar el comentario de todas formas?</strong></div>`,
                    confirmButtonText: 'Sí, enviar de todas formas',
                    denyButtonText: 'No, seleccionar archivos',
                    denyButtonColor: '#3085d6',
                    showDenyButton: true,
                    focusDeny: true
                })
                    .then((res) => {
                        abrir_modal = res.isDenied
                        // si pone que no o hace click fuera del modal no hace nada
                        if (!res.isConfirmed) {
                            ups_me_olvide_el_archivo = true
                        }
                    })
                if (abrir_modal) this.dialog_archivos = true
                if (ups_me_olvide_el_archivo) return
            }
            this.$store.state.loading = true
            let archivos = []
            let nombreArchivos = []
            // convierto los archivos en base64


            if (this.archivos_adjuntos.length > 0) {
                for (const archivo of this.archivos_adjuntos) {
                    // Convertir a WebP si es imagen, o dejar el archivo original si no lo es
                    const archivoConvertido = await convertImageToWebp(archivo);
                    // Agregar el nombre del archivo convertido (con extensión .webp si aplicó)
                    nombreArchivos.push(archivoConvertido.name);
                    // Convertir a base64
                    const fileBase64 = await getBase64(archivoConvertido);
                    archivos.push(fileBase64);
                }
            }

            let es_comentario_mesa = 0
            if (this.roles_de_usuario.some(rol => rol.Rol_id === 1)) {
                es_comentario_mesa = 1
            }

            await this.$store.dispatch('tickets/nuevoComentario', {
                id: this.selected[0].ticket_id,
                comentario: this.comentario,
                es_comentario_mesa,
                usuario_nombre: `${this.$store.state.usuario.nombre} ${this.$store.state.usuario.apellido}`,
                estado_ticket_id: this.selected[0].estado_id,
                es_comentario_interno: 0
            })
                .then(async (res) => {
                    if (res.exito) {
                        this.comentario = ''
                        this.comentarios.push(res.data)
                        if (archivos.length === 0) {
                            await this.$swal.fire({
                                icon: res.exito ? 'success' : 'warning',
                                title: res.message,
                            })
                        } else {
                            await this.$store
                                .dispatch('tickets/cargarArchivos', {
                                    archivos,
                                    nombreArchivos,
                                    ticket_id: this.selected[0].ticket_id,
                                    estado_id: this.selected[0].estado_id,
                                    comentario_id: res.data.comentario_id
                                })
                                .then(resArchivos => {
                                    if (resArchivos.exito) {
                                        this.archivos_adjuntos = []
                                        resArchivos.data.forEach(archivo => {
                                            this.archivos.push(archivo)
                                        })
                                        if (resArchivos.feedbackFallidos.length > 0) {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                                html: `<strong>${resArchivos.feedbackFallidos}</strong>`,
                                                width: '450px'
                                            })
                                        } else {
                                            this.$swal.fire({
                                                icon: 'success',
                                                title: resArchivos.message,
                                            })
                                        }
                                    } else {
                                        this.$store.dispatch('show_snackbar', {
                                            text: resArchivos.message,
                                            color: 'error'
                                        })
                                    }
                                })
                        }
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        })
                    }
                })
                .catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    })
                })
            this.$store.state.loading = false
        },


        ver_archivo(archivo, ruta) {
            const tipo = this.get_atributo_x_extension(archivo.extension, 'tipo')
            this.nombre_ver = archivo.nombre
            if (tipo == 'IMG') {
                this.img = archivo.url
                this.dialog_img = true
            }
            else if (tipo == 'PDF') {
                this.pdf = archivo.url
                this.dialog_pdf = true
            }
            else {
                window.open(archivo.url, '_blank')
            }
        },

        rowClick(item) {
            // Deseleccionar si ya está seleccionado
            if (this.selected.length > 0 && this.selected[0].ticket_id === item.ticket_id) {
                this.selected = [];
            } else {
                this.selected = [item];
            }
            this.$nextTick(() => {
                if (this.selected.length > 0) {
                    this.$vuetify.goTo('#detalle');
                }
            });
        },
        // obtiene un atributo especifico del array tipos_archivos en base a la extension del archivo indicado
        get_atributo_x_extension(extension, atributo) {
            return tipos_archivos.find(a => a.extension == extension) ? tipos_archivos.find(a => a.extension == extension)[atributo] : ''
        },


        abrirModalDescargar() {
            this.modalDescargar = true
        },

        descargarReporte() {
            if (this.tickets.length > 0) {

                const cabecera = [['N° TICKET', 'FECHA CREACIÓN', 'HORA CREACIÓN', 'TIPO TICKET', 'ESTADO', 'USUARIO SOLICITANTE', 'NOMBRE SOLICITANTE', 'ASUNTO', 'DESCRIPCIÓN', 'RESPUESTA', 'USUARIO ASIGNADO', 'USUARIO FINALIZACIÓN', 'FECHA FINALIZACIÓN', 'COMENTARIO']]

                const ws = utils.aoa_to_sheet(cabecera)
                const array = []

                const ticketsOrdenados = this.tickets.sort((a,b) => b.ticket_id - a.ticket_id)

                ticketsOrdenados.forEach(ticket => {
                    // ACA SETEAR LA HORA DE CREACION
                    ticket.fecha_creacion_format = ticket.fecha_creacion ? moment.utc(ticket.fecha_creacion).format('DD/MM/YYYY') : ''
                    ticket.hora_creacion_format = ticket.fecha_creacion ? moment.utc(ticket.fecha_creacion).format('HH:MM')  : ''
                    ticket.fecha_finalizacion_format = ticket.fecha_finalizacion ? moment.utc(ticket.fecha_finalizacion).format('DD/MM/YYYY') : ''

                    let data = {
                        ticket_id: ticket.ticket_id,
                        fecha_creacion: ticket.fecha_creacion_format,
                        hora_creacion: ticket.hora_creacion_format,
                        tipo: ticket.tipo_ticket_nombre,
                        estado: ticket.estado_nombre,
                        usuario_solicitante: ticket.usuario_solicitante_nombre,
                        nombre_solicitante: ticket.solicitante_nombre,
                        asunto: ticket.asunto,
                        descripcion: ticket.descripcion,
                        respuesta: ticket.respuesta,
                        usuario_asignado: ticket.usuario_asignado_nombre,
                        usuario_finalizacion: ticket.usuario_finalizacion,
                        fecha_finalizacion: ticket.fecha_finalizacion_format,
                        comentario: ticket.comentario
                    }

                    array.push(data)
                })

                utils.sheet_add_json(ws, array, {
                    header: [
                        'ticket_id',
                        'fecha_creacion',
                        'hora_creacion',
                        'tipo',
                        'estado',
                        'usuario_solicitante',
                        'nombre_solicitante',
                        'asunto',
                        'descripcion',
                        'respuesta',
                        'usuario_asignado',
                        'usuario_finalizacion',
                        'fecha_finalizacion',
                        'comentario'
                    ],
                    skipHeader: true,
                    origin: -1
                })

                // Ajusto ancho de columnas automáticamente
                const columnas = Object.keys(array[0])
                columnas.forEach(columna => {
                    const maxLength = array.reduce(
                        (max, row) => Math.max(max, String(row[columna]).length),
                        0
                    )
                    ws['!cols'] = ws['!cols'] || []
                    ws['!cols'].push({ wch: maxLength + 2 })
                })

                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Reporte')
                const wbout = write(wb, { bookType: 'xlsx', type: 'array' })
                let name = 'Reporte_tickets_' + moment().format('DD/MM/YYYY') + '.xlsx'
                FileSaver.saveAs(
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    name
                )
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: 'Debes filtrar en la tabla antes de descargar el reporte.',
                    color: 'warning'
                })
            }
        },
        limpiar() {
            this.search = ''
            this.filtro = {
                id: '',
                asunto: '',
                estado: null,
                tipo: null,
                periodo_creacion: '',
                area: null,
                ver_mis_propios_tickets: false
            }
        }
    }
}
</script>
